import mixins, { toast } from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"
import store from "@/store"

import { DateTime } from "luxon"

import { checkIsCustomerTokenAvailable } from "@/api/api-module-iam"
import { getVeeamList } from "@/api/api-module3"

import {
  PermissionUser,
  routePermissions,
  routesPermissionAccessMenu,
} from "@/constants/permission-user"

export function initialAppLoading() {
  mixins.methods.showLoading(true)
}

export function removeAppLoading() {
  mixins.methods.showLoading(false)
}

function redirectTo(path, next) {
  next({
    path: path,
    replace: true,
  })
}

async function updateNavbarSidebar(destination) {
  if (destination.meta?.type === "internal") {
    // SET FIRST SIDEBAR MENU EACH MODULE
    await handleInternalNavbarPermission()
    // SET NAVBAR MODULES MENU
    const navbarModules = {
      webPortal: mixinsUser.methods.hasModulePermission("wpm"),
      serverManagement: mixinsUser.methods.hasModulePermission("sms"),
      backupManagement: mixinsUser.methods.hasModulePermission("bmm"),
      networkConfiguration: mixinsUser.methods.hasModulePermission("ncm"),
    }
    store.dispatch("verticalMenu/setInternalEnabledNavbar", navbarModules)

    // SET M1 SIDEBAR MENU
    const reportAccessPermissionList = [
      PermissionUser.WPM.REPORT_TICKET_READ,
      PermissionUser.WPM.REPORT_SITE_ACCESS_READ,
      PermissionUser.WPM.REPORT_NTDC_CONTRACT_READ,
      PermissionUser.WPM.REPORT_IPAM_READ,
      PermissionUser.WPM.REPORT_WORKLOAD_READ,
    ]
    const sidebarWebPortalModule = {
      wpmDashboardTechnicalAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.DASHBOARD_READ
      ),
      wpmDashboardExecutiveAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.EXCECUTIVE_DASHBOARD_READ
      ),
      wpmTicketTrackingAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.TICKET_READ
      ),
      wpmTicketEscalationAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.TICKET_ESCALATION_READ
      ),
      wpmQrAccessAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.SITE_ACCESS_READ
      ),
      siteAccessDashboard: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.SITE_ACCESS_DASHBOARD_READ
      ),
      // wpmSmartHandManagementAccess: mixinsUser.methods.hasPermission(
      //   PermissionUser.WPM.SMART_HAND_READ
      // ),
      // wpmCrossConnectAccess: Boolean(
      //   PermissionUser.WPM.CROSS_CONNECT_READ
      // ),
      // wpmParcelTrackingAccess: Boolean(
      //   PermissionUser.WPM.PARCEL_TRACKING_READ
      // ),
      // wpmInventoryManagementAccess: Boolean(
      //   PermissionUser.WPM.INVENTORY_READ
      // ),
      wpmIdcDatabaseAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.NTDC_CONTRACT_READ
      ),
      // wpmIdcDatabaseAccessContractApproval: mixinsUser.methods.hasPermission(
      //   PermissionUser.WPM.NTDC_CONTRACT_APPROVAL_WRITE
      // ),
      // wpmIdcDatabaseAccessUpdateContract: Boolean(
      //   internalUserPermissions.wpmIdcDatabaseAccessUpdateContract
      // ),
      wpmIdcCustomerAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.NTDC_CUSTOMER_READ
      ),
      // wpmIdcCustomerAccessCreate: Boolean(
      //   internalUserPermissions.wpmIdcCustomerAccessCreate
      // ),
      // wpmIdcCustomerAccessUpdate: Boolean(
      //   internalUserPermissions.wpmIdcCustomerAccessUpdate
      // ),
      wpmIdcContactPointAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.NTDC_CONTACT_POINT_READ
      ),
      // wpmIdcContactPointAccessCreate: Boolean(
      //   internalUserPermissions.wpmIdcContactPointAccessCreate
      // ),
      // wpmIdcContactPointAccessUpdate: Boolean(
      //   internalUserPermissions.wpmIdcContactPointAccessUpdate
      // ),
      wpmContractAttachmentAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.NTDC_ATTACHMENT_READ
      ),
      wpmIpamAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.IPAM_READ
      ),
      // wpmIpamAccessManage: Boolean(internalUserPermissions.wpmIpamAccessManage),
      wpmReportAccess: reportAccessPermissionList.some((perm) =>
        mixinsUser.methods.hasPermission(perm)
      ),
      wpmWorkloadAccess: mixinsUser.methods.hasPermission(
        PermissionUser.WPM.WORKLOAD_READ
      ),
    }
    store.dispatch(
      "verticalMenu/setInternalWebPortalModuleEnabledSidebar",
      sidebarWebPortalModule
    )

    // SET M2 SIDEBAR MENU
    const sidebarServerManagementModule = {
      smsDashboardAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.DASHBOARD_READ
      ),
      smsAllEventsAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.ALL_EVENTS_READ
      ),
      smsServerManagementAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.SERVER_MANAGEMENT_READ
      ),
      smsAlertAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.ALERT_READ
      ),
      smsReportAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.REPORT_READ
      ),
      smsDiscoveryAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.DISCOVERY_READ
      ),
      smsPolicyAccess: mixinsUser.methods.hasPermission(
        PermissionUser.SMS.POLICY_READ
      ),
    }
    store.dispatch(
      "verticalMenu/setInternalServerManagementModuleEnabledSidebar",
      sidebarServerManagementModule
    )

    // SET M3 SIDEBAR MENU
    const sidebarBackupManagementModule = {
      bmmDashboardAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.DASHBOARD_READ
      ),
      bmmRepositoryAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.REPOSITORY_READ
      ),
      bmmManagedServerAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.SERVER_MANAGEMENT_READ
      ),
      bmmCredentialAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.CREDENTIAL_READ
      ),
      bmmVeeamAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.VEEAM_READ
      ),
      bmmBackupAndRestoreAccess: mixinsUser.methods.hasPermission(
        PermissionUser.BMM.BACKUP_READ
      ),
    }
    store.dispatch(
      "verticalMenu/setInternalBackupManagementModuleEnabledSidebar",
      sidebarBackupManagementModule
    )

    // SET M4 SIDEBAR MENU
    const sidebarNetworkConfigurationModule = {
      ncmDashboardAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.DASHBOARD_READ
      ),
      ncmNodeManagementAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.NODE_MANAGEMENT_READ
      ),
      ncmConfigHistoryAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.CONFIG_HISTORY_READ
      ),
      ncmConfigTemplateAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.CONFIG_TEMPLATE_READ
      ),
      ncmConfigComparisonAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.CONFIG_COMPARISON_READ
      ),
      ncmDiscoveryNodeAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.DISCOVERY_NODE_READ
      ),
      ncmCredentialAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.CREDENTIAL_READ
      ),
      ncmBackupSettingsAccess: mixinsUser.methods.hasPermission(
        PermissionUser.NCM.BACKUP_SETTINGS_READ
      ),
    }
    store.dispatch(
      "verticalMenu/setInternalNetworkConfigurationModuleEnabledSidebar",
      sidebarNetworkConfigurationModule
    )
  } else {
    /* CUSTOMER MENU MANAGEMENT START */
    if (!!store.state.appPermission.permissions) {
      const permissions = JSON.parse(store.state.appPermission.permissions)
      const userPermissions = Object.keys(permissions).reduce((object, key) => {
        permissions[key] === true && (object[key] = permissions[key])
        return object
      }, {})

      /* SET ENABLED CUSTOMER NAVBAR START */
      handleCustomerNavbarPermission(userPermissions)
      const navbarModules = {
        webPortal: Boolean(userPermissions.wpmAccess),
        serverManagement: false,
        backupManagement: false,
        networkConfiguration: false,
      }
      store.dispatch("verticalMenu/setEnabledNavbar", navbarModules)
      /* SET ENABLED CUSTOMER NAVBAR END */

      /* SET CUSTOMER WEB PORTAL SIDEBAR START */
      const sidebarWebPortalModule = {
        wpmDashboardTechnicalAccess: Boolean(
          userPermissions.wpmDashboardTechnicalAccess
        ),
        wpmDashboardExecutiveAccess: Boolean(
          userPermissions.wpmDashboardExecutiveAccess
        ),
        wpmTicketTrackingAccess: Boolean(
          userPermissions.wpmTicketTrackingAccess
        ),
        wpmQrAccessAccess: Boolean(userPermissions.wpmQrAccessAccess),
        wpmSmartHandManagementAccess: Boolean(
          userPermissions.wpmSmartHandManagementAccess
        ),
        wpmCrossConnectAccess: Boolean(userPermissions.wpmCrossConnectAccess),
        wpmParcelTrackingAccess: Boolean(
          userPermissions.wpmParcelTrackingAccess
        ),
        wpmInventoryManagementAccess: Boolean(
          userPermissions.wpmInventoryManagementAccess
        ),
        wpmIdcDatabaseAccess: Boolean(userPermissions.wpmIdcDatabaseAccess),
        wpmIdcDatabaseAccessContractApproval: Boolean(
          userPermissions.wpmIdcDatabaseAccessContractApproval
        ),
        wpmIdcDatabaseAccessUpdateContract: Boolean(
          userPermissions.wpmIdcDatabaseAccessUpdateContract
        ),
        wpmIdcCustomerAccess: Boolean(userPermissions.wpmIdcCustomerAccess),
        wpmIdcCustomerAccessCreate: Boolean(
          userPermissions.wpmIdcCustomerAccessCreate
        ),
        wpmIdcCustomerAccessUpdate: Boolean(
          userPermissions.wpmIdcCustomerAccessUpdate
        ),
        wpmIdcContactPointAccess: Boolean(
          userPermissions.wpmIdcContactPointAccess
        ),
        wpmIdcContactPointAccessCreate: Boolean(
          userPermissions.wpmIdcContactPointAccessCreate
        ),
        wpmIdcContactPointAccessUpdate: Boolean(
          userPermissions.wpmIdcContactPointAccessUpdate
        ),
        wpmContractAttachmentAccess: Boolean(
          userPermissions.wpmContractAttachmentAccess
        ),
        wpmIpamAccess: Boolean(userPermissions.wpmIpamAccess),
        wpmIpamAccessManage: Boolean(userPermissions.wpmIpamAccessManage),
        wpmReportAccess: Boolean(userPermissions.wpmReportAccess),
      }
      store.dispatch(
        "verticalMenu/setWebPortalModuleEnabledSidebar",
        sidebarWebPortalModule
      )
      /* SET CUSTOMER WEB PORTAL SIDEBAR END */
      /* CUSTOMER MENU MANAGEMENT END */
    }
  }
}

async function checkPermissionAccess(
  destination,
  next,
  isFromInternalLoginPage,
  isFromCustomerLoginPage
) {
  const handleTokenExpiration = async (
    isInternalUser,
    isFromLoginPage,
    next
  ) => {
    const authStore = store.state.authStore
    const token = isInternalUser
      ? authStore.user.access_token
      : store.state.appPermission.token
    const externalTokenExpireAt = store.state.appPermission.tokenExpireAt

    if (isInternalUser) {
      // NOTE: Math.floor(DateTime.now().toSeconds()) === dayjs().unix()
      if (
        !token ||
        authStore.user?.expires_at < Math.floor(DateTime.now().toSeconds())
      ) {
        if (
          !isFromLoginPage &&
          destination.fullPath.toLowerCase() !== "/internal/login"
        ) {
          await store.dispatch("authStore/logoutOidc")
          return redirectTo("/internal/login", next)
        }
      }
    } else {
      if (
        !token ||
        DateTime.fromISO(externalTokenExpireAt).toUTC() < DateTime.utc()
      ) {
        await store.dispatch("appPermission/userLogout")
        return redirectTo("/login", next)
      }
    }

    return true
  }

  if (destination.meta?.type === "internal") {
    if (!handleTokenExpiration(true, isFromInternalLoginPage, next)) {
      return false
    }

    const requiredPermissions = destination.meta.permission
    let hasPermission = false

    if (Array.isArray(requiredPermissions)) {
      hasPermission = requiredPermissions.some((perm) =>
        mixinsUser.methods.hasPermission(perm)
      )
    } else if (typeof requiredPermissions === "string") {
      hasPermission = mixinsUser.methods.hasPermission(requiredPermissions)
    }

    if (!hasPermission) {
      redirectTo("/internal/no-permission", next)
      return false
    }

    return hasPermission
  } else {
    await store.dispatch("appPermission/setAccessPermissionFromLocalStorage")

    if (!handleTokenExpiration(false, isFromCustomerLoginPage, next)) {
      return false
    }

    if (!!store.state.appPermission.permissions) {
      const externalPermissions = JSON.parse(
        store.state.appPermission.permissions
      )
      const externalUserPermissions = Object.keys(externalPermissions).reduce(
        (object, key) => {
          externalPermissions[key] === true &&
            (object[key] = externalPermissions[key])
          return object
        },
        {}
      )

      const hasPermission = Object.keys(externalUserPermissions).find(
        (permission) => permission === destination.meta.permission
      )

      if (!hasPermission) {
        redirectTo("/no-permission", next)
        return false
      }

      return hasPermission
    } else {
      return false
    }
  }
}

//
// CUSTOMER
//
async function handleCustomerNavbarPermission(userPermissions) {
  await store.dispatch(
    "verticalMenu/setFirstCustomerWpmPermission",
    findFirstCustomerWpmPermission(userPermissions)
  )
}

function findFirstCustomerWpmPermission(userPermissions) {
  if (userPermissions.login) {
    return "login"
  } else if (userPermissions.wpmTicketTrackingAccess) {
    return "wpmTicketTrackingAccess"
  } else if (userPermissions.wpmQrAccessAccess) {
    return "wpmQrAccessAccess"
  } else if (userPermissions.wpmSmartHandManagementAccess) {
    return "wpmSmartHandManagementAccess"
  } else if (userPermissions.wpmCrossConnectAccess) {
    return "wpmCrossConnectAccess"
  } else if (userPermissions.wpmParcelTrackingAccess) {
    return "wpmParcelTrackingAccess"
  } else {
    return ""
  }
}

//
// INTERNAL
//
async function handleInternalNavbarPermission() {
  await store.dispatch(
    "verticalMenu/setFirstInternalWpmPermission",
    mixinsUser.methods.getModuleFirstReadPermission("wpm")
  )
  await store.dispatch(
    "verticalMenu/setFirstInternalSmsPermission",
    mixinsUser.methods.getModuleFirstReadPermission("sms")
  )
  await store.dispatch(
    "verticalMenu/setFirstInternalBmmPermission",
    mixinsUser.methods.getModuleFirstReadPermission("bmm")
  )
  await store.dispatch(
    "verticalMenu/setFirstInternalNcmPermission",
    mixinsUser.methods.getModuleFirstReadPermission("ncm")
  )
}

const isAccess = (to) => {
  const requiredPermissions = routePermissions[to.name]

  if (!requiredPermissions) {
    // console.warn(`No permissions defined for route: ${to.name}`)
    return true
  }

  const hasRequiredPermissions = requiredPermissions.some((perm) =>
    mixinsUser.methods.hasPermission(perm)
  )

  if (!hasRequiredPermissions) {
    console.log(`No permission for route: ${to.name}`)
    toast.error("No Permission")
  }

  return hasRequiredPermissions
}

const nextRouter = (next) => {
  const route = routesPermissionAccessMenu.find((route) =>
    route.permission.some((perm) => mixinsUser.methods.hasPermission(perm))
  )

  if (route) {
    redirectTo(route.path, next)
  }
}

export async function handleRouterBeforeEach(to, from, next) {
  const isFromCustomerLoginPage = from.fullPath === "/login"
  const isFromInternalLoginPage = from.fullPath === "/internal/login"

  if (
    to.meta.type === "internal" &&
    to.fullPath.toLowerCase() !== "/internal/login"
  ) {
    await store.dispatch("authStore/checkUser")
    const authStore = store.state.authStore

    if (to.meta.module === "webPortal") {
      await store.dispatch("siteStore/fetchSite")
    }

    if (authStore.isAuthenticated) {
      if (Math.floor(DateTime.now().toSeconds()) > authStore.user?.expires_at)
        await store.dispatch("authStore/renewToken")
      else if (isAccess(to)) next()
      else nextRouter(next)
    } else {
      return redirectTo("/internal/login", next)
    }
  }

  store.dispatch("appPermission/setAccessPermissionFromLocalStorage")
  const token = store.state.appPermission.token
  if (to.meta.type === "external") {
    try {
      if (!token) throw new Error("Token not found")
      await checkIsCustomerTokenAvailable(token)
    } catch (error) {
      if (!isFromCustomerLoginPage && to.fullPath.toLowerCase() !== "/login") {
        await store.dispatch("appPermission/userLogout")
        return redirectTo("/login", next)
      }
    }
  }

  if (to.meta?.permission) {
    const hasPermissionToAccess = checkPermissionAccess(
      to,
      next,
      isFromInternalLoginPage,
      isFromCustomerLoginPage
    )

    if (!hasPermissionToAccess) {
      if (to.meta?.type === "internal") {
        return redirectTo("/internal/no-permission", next)
      } else {
        return redirectTo("/no-permission", next)
      }
    }

    await updateNavbarSidebar(to)
  }

  await updateNavbarSidebar(to)

  if (to.fullPath.toLowerCase() === "/internal/login") {
    await store.dispatch("authStore/checkUser")
    const authStore = store.state.authStore

    if (authStore.isAuthenticated) {
      if (Math.floor(DateTime.now().toSeconds()) > authStore.user?.expires_at) {
        await store.dispatch("authStore/renewToken")
        return redirectTo("/internal", next)
      } else if (
        authStore.user?.expires_at > Math.floor(DateTime.now().toSeconds())
      ) {
        store.dispatch("verticalMenu/setCurrentModuleNavbar", to.meta.module)
        return redirectTo("/internal", next)
      }
    }
  }

  if (to.fullPath.toLowerCase() === "/login") {
    store.dispatch("appPermission/setAccessPermissionFromLocalStorage")
    const token = store.state.appPermission.token
    const tokenExpireAt = store.state.appPermission.tokenExpireAt
    if (!!token && DateTime.fromISO(tokenExpireAt).toUTC() > DateTime.utc()) {
      store.dispatch("verticalMenu/setCurrentModuleNavbar", to.meta.module)
      return redirectTo("/", next)
    }
  }

  store.dispatch("verticalMenu/setCurrentModuleNavbar", to.meta.module)
  next()
  return true
}

export async function handleRouterAfterEach(to) {
  if (to.name === "home" || to.name === "internalHome") {
    store.dispatch("appConfig/setLayoutSidebar", false)
  } else if (
    to.path.includes("global-settings") &&
    !to.path.includes("data-management")
  ) {
    store.dispatch("appConfig/setLayoutSidebar", false)
  } else if (to.path.includes("edit-profile")) {
    store.dispatch("appConfig/setLayoutSidebar", false)
  } else {
    store.dispatch("appConfig/setLayoutSidebar", true)
  }

  // Handle Veeam Options [M3]
  if (to.meta?.module === "backupManagement") {
    let veeamList = []
    await getVeeamList().then((response) => {
      if (response) {
        response.data.forEach((veeam) => {
          veeamList.push({
            id: veeam.veeamId,
            name: veeam.veeamName,
            ip: veeam.veeamAddress,
            port: veeam.veeamPort,
            username: veeam.veeamUsername,
            description: veeam.veeamDescription,
          })
        })
      }
    })
    store.dispatch("app/setVeeamList", veeamList)
    if (store.state.app.veeamCurrentServer.id === "") {
      let currentVeeamServer = sessionStorage.getItem("current-veeam-server")
      if (currentVeeamServer) {
        store.dispatch(
          "app/setCurrentVeeamServer",
          JSON.parse(currentVeeamServer)
        )
      } else {
        currentVeeamServer = localStorage.getItem("current-veeam-server")
        store.dispatch(
          "app/setCurrentVeeamServer",
          JSON.parse(currentVeeamServer)
        )
      }
    }
  }
}
